module.exports = __webpack_public_path__ + "img/Group 27919@2x.b69eaba4.png";